export default "__VITE_ASSET__Bh$fPA5i__"